import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';

import {map, Observable} from 'rxjs';

import {DataBatchDto, LoadDataBatchFiltersDto} from '../dtos/load-data-batch.dto';

@Injectable({
  providedIn: 'root',
})
export class DataBatchService {
  readonly #http: HttpClient = inject(HttpClient);
  readonly #url: string = S2WX_API_URL + '/DataBatch';

  #buildQueryParams(fromObject: LoadDataBatchFiltersDto): HttpParams {
    return new HttpParams({fromObject});
  }

  public loadDataBatch(dimensionLevelName: string, filters: LoadDataBatchFiltersDto): Observable<DataBatchDto> {
    const params: HttpParams = this.#buildQueryParams(filters);
    return this.#http.get<DataBatchDto>(`${this.#url}/${dimensionLevelName}`, {
      params,
      observe: 'response',
    })
      .pipe(
        map(response => ({
          ...(response.body as DataBatchDto),
          summarizationKey: response.headers.get('x-summarize-key'),
        })),
      );
  }

  public loadHighlights(dataBatchHash: string, highlightStrategyName: string): Observable<number[]> {
    const params = {dataBatchHash, highlightStrategyName};
    return this.#http.get<HighlightsResponse>(`${this.#url}/highlights`, {
      params,
    })
      .pipe(
        map(res => {
          return res.highlights.map(obj => obj.id);
        }),
      );
  }
}

interface HighlightsResponse {
  highlights: Array<{ id: number }>;
}
